import { motion } from "framer-motion";

const line = {
  initial: { y: "110%" },
  enter: (i = 0) => ({
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1],
      delay: 0.1 + i * 0.12,
    },
  }),
};

export function MaskedLine({ children, i = 0, className = "" }) {
  return (
    <span className="line-mask block">
      <motion.span
        className={`block ${className}`}
        initial="initial"
        animate="enter"
        variants={line}
        custom={i}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function FadeUp({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
